module.exports = __webpack_public_path__ + "img/Réalisation portail.6b90ff1c.jpg";